import(/* webpackMode: "eager" */ "/kingsyard-ssr/src/app/(app)/checkout/page.js");
